import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import en from 'element-ui/lib/locale/lang/en'
import chs from 'element-ui/lib/locale/lang/zh-CN'
import tc from 'element-ui/lib/locale/lang/zh-TW'
const lang = localStorage.getItem('lang') || 'tc'
let locale = tc
if (lang === 'tc') {
  locale = tc
}
if (lang === 'chs') {
  locale = chs
}
if (lang === 'en') {
  locale = en
}
Vue.use(Element, { locale })
